module.exports = __webpack_public_path__ + "img/1529821639.4de2a74f.jpg";